<template>
</template>


<script>

export default {
    props: {
        propProfile: { 
            type: String, 
            default: ''
        },
        propMCode: {
            type: String,
            default: ''
        },
        deep: {
            type: Number,
            default: null
        },
        myBundle: {
            type: Boolean,
            default: false
        }
    },
    mounted: function(){
        if(this.propProfile)
         this.$router.push({name: 'profile', params: {propProfile: this.propProfile, propMCode: this.propMCode, deep: this.deep, myBundle: this.myBundle}})
        else
         this.$router.push('/profile')
    }
}

</script>